var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"header"},[_vm._v("Unsere Dienstleistungen")]),_c('service-list',{staticClass:"service-list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }